import Styles from "./UpdateNews.module.scss";
import clsx from "clsx";
import { useNavigate, useParams } from "react-router-dom";
import { SwalError, SwalFail, SwalSuccess } from "../../../../Share/Swal";
import {
  CallApiUpdateNew,
  CallApiGetNewById,
} from "../../../../Api/Enforcement";
import { adminNews } from "../../../../Api/SubUrl";
import NewsForm from "../../../../Components/Molecules/NewsForm";
import { useEffect, useState, useCallback } from "react";
function UpdateNew() {
  let { id } = useParams();
  const [newDetail, setNewDetail] = useState(null);

  const handleCallApiNewByID = useCallback(() => {
    CallApiGetNewById(id.slice(id.indexOf("d") + 1), (res) => {
      if ((res.Status = "success")) {
        const data = res.Response.data;
        setNewDetail(data);
      }
    });
  }, [id]);

  useEffect(() => {
    handleCallApiNewByID();
  }, [handleCallApiNewByID]);

  const navigate = useNavigate();

  const handleUpdateNew = (data, image) => {
    const formattedData = {
      ...data,
      type: data.type.value,
      img: image,
    };
    CallApiUpdateNew(id.slice(id.indexOf("d") + 1), formattedData, (res) => {
      if (res === "success") {
        SwalSuccess("Cập nhật tin tức thành công!");
        navigate(adminNews);
      } else {
        const status = res.Status.status;
        const message = res.Status.data.Message;
        if (status === 400) SwalFail(message);
        else
          SwalError(
            "Đã có lỗi xảy ra!\n Tải lại trang hoặc liên hệ để được hỗ trợ!"
          );
      }
    });
  };

  return (
    <div className={clsx(Styles.main)}>
      <div className={clsx(Styles.topMain)}>
        <h1 className={clsx(Styles.topMainTitle)}>Cập nhật tin tức</h1>
      </div>
      <div className={clsx(Styles.bodyMain)}>
        <NewsForm
          onSubmit={handleUpdateNew}
          buttonText="Cập nhật"
          initialData={newDetail}
        />
      </div>
    </div>
  );
}

export default UpdateNew;
